import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const StyledCursor = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  background: #0ff;
  box-shadow: 0 0 10px #0ff, 0 0 20px #0ff, 0 0 30px #0ff;
  border: 2px solid #0ff;
  border-radius: 30px;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 50;
  transition: ${(props) => (props.click ? 'transform 0.3s' : 'none')};
  transform: ${(props) => (props.click ? 'scale(2)' : 'scale(1)')};
  animation: glowMove 4s linear infinite;
  opacity: 0.4;

  @keyframes glowMove {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 400% 50%;
    }
  }
`;

const NeonButton = styled.button`
  
  background: transparent;
  border: 2px solid #0ff;
  border-radius: 30px;
  cursor: pointer;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px #0ff, 0 0 10px #0ff;

  &:hover {
    background: #0ff;
    color: #000;
    box-shadow: 0 0 10px #0ff, 0 0 20px #0ff, 0 0 30px #0ff;
  }

  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    z-index: -1;
    background: linear-gradient(90deg, #0ff, #00f, #0ff);
    background-size: 400%;
    border-radius: 30px;
    animation: glowMove 4s linear infinite;
    opacity: 0.4;
  }

  @keyframes glowMove {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 400% 50%;
    }
  }
`;



const Cursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [click, setClick] = useState(false);

  useEffect(() => {
    const updatePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const updateClick = () => {
      setClick(true);
      setTimeout(() => setClick(false), 300); // Reset click state after 300ms
    };

    document.addEventListener('mousemove', updatePosition);
    document.addEventListener('click', updateClick);

    return () => {
      document.removeEventListener('mousemove', updatePosition);
      document.removeEventListener('click', updateClick);
    };
  }, []);

  return (
    <StyledCursor
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
      click={click}
    />
  );
};

export default Cursor;